module.exports = __webpack_public_path__ + "img/icon-download.f0745539.svg";